import React from 'react';
import { GradientName } from '~/interfaces/GradientName';
import '~/styles/common/gradients/gradients.scss';
import styles from './tab.module.scss';
import classNames from 'classnames';

export type TabProps = {
  /**
   * If 'true', Tab is in active state
   */
  active?: boolean;
  /**
   * Tab bottom border gradient name, 'multi1' by default
   */
  gradient?: GradientName;
  /**
   * Label displayed inside the Tab
   */
  label?: string;
  /**
   * Affects label color
   */
  darkMode?: boolean;
  /**
   * Callback used when the Tab is pressed
   */
  onClick?(): void;
  /**
   * If 'true', Tab is disabled
   *
   */
  disabled?: boolean;
};

export const Tab = (props: TabProps) => {
  const { gradient = 'multi1', label, active = false, darkMode, onClick, disabled = false } = props;

  return (
    <button
      className={classNames([styles.tabRoot, { [styles.disabled]: disabled }])}
      onClick={disabled ? undefined : onClick}
    >
      <span className={classNames([styles.tabLabel, { [styles.tabLabelActive]: active }, { [styles.dark]: darkMode }])}>
        {label}
      </span>
      {active && <div className={classNames([styles.tabUnderline, active ? `${gradient}Horizontal` : ''])} />}
    </button>
  );
};
